import { TTransshipmentStepId } from '../types';
import { TStep } from './steps.types';

import initial from './initial';
import { representativeWelcome, spouseWelcome } from './welcome';
import {
  representativeFinalizePersonalData,
  spouseFinalizePersonalData,
} from './finalizePersonalData';
import maritalStatus from './maritalStatus';
import spouseRegister from './spouseRegister';
import identityDocumentType from './identityDocumentType';
import rg from './rg';
import cnh from './cnh';
import selfie from './selfie';
import documentsSuccess from './documentsSuccess';
import accountPassword from './accountPassword';
import success from './success';

const states: Record<TTransshipmentStepId, TStep> = {
  initial,
  'representative-welcome-page': representativeWelcome,
  'spouse-welcome-page': spouseWelcome,

  'representative-finalize-personal-data-page':
    representativeFinalizePersonalData,
  'marital-status-page': maritalStatus,
  'spouse-register-page': spouseRegister,

  'spouse-finalize-personal-data-page': spouseFinalizePersonalData,

  'identity-document-type-page': identityDocumentType,

  'rg-page': rg,
  'cnh-page': cnh,
  'selfie-page': selfie,

  'documents-success-page': documentsSuccess,

  'account-password-page': accountPassword,

  'success-page': success,
};

export default states;
